/* eslint-disable react/no-unstable-nested-components */
import React from 'react';

import ContentFeed from '../ContentFeed';
import ProductCard from '../ProductCard';

const ns = `popular-products`;

function PopularProducts({
	collection,
	title = 'Popular Products',
	location,
	initialVisibleAmount,
	onLoadMore,
	isLoading
}) {
	return (
		<div className={ns}>
			<h3 className={`${ ns }__title h3`}>{title}</h3>
			<ContentFeed
				location={location}
				page={'category'}
				noContainer
				items={collection.products.slice(0, 4)}
				onLoadMore={onLoadMore}
				isLoading={isLoading}
				itemView={(p, index) => {
					return (
						<ProductCard
							location={location}
							product={p}
							key={p.id}
							index={index}
							hideQuickshop
							hideTag
							hideRating
						/>
					);
				}}
				initialVisibleAmount={initialVisibleAmount || 4}
			/>
		</div>
	);
}

export default PopularProducts;
